module.exports = __webpack_public_path__ + "static/img/protect.b5fc4d8d.png";